import { Component, Input } from '@angular/core';
import { ComponentDataResolver } from '@core/dynamic-components/types';

import { FamilyBlock } from './types/jb-family-brand-block.type';

@Component({
  selector: 'jb-family-brand-block',
  templateUrl: './jb-family-brand-block.component.html',
  host: {
    class: 'db tc',
  },
  styleUrls: ['./jb-family-brand-block.component.scss'],
})
export class JbFamilyBrandBlockComponent {
  /** The header text displayed above the brand blocks */
  @Input() header: string = '';

  /** Collection of brand blocks to display */
  @Input() familyBlocks: FamilyBlock[] = [];

  // Component data resolver to map CMS data to component inputs
  static componentDataResolver: ComponentDataResolver = (registry, data) => {
    // Handle different possible CMS data structures
    let familyBlockData;

    // Case 1: Direct familyBlock data (when component is referenced directly)
    if (data.familyBlock) {
      familyBlockData = data.familyBlock[0]?.data || data.familyBlock;
    }
    // Case 2: Nested within section (as shown in the CMS data)
    else if (data.familyBlocks) {
      familyBlockData = data;
    }
    // Case 3: Fallback to direct data
    else {
      familyBlockData = data;
    }

    return {
      header: familyBlockData.header || '',
      familyBlocks: (familyBlockData.familyBlocks || []).map(block => ({
        label: block.label || '',
        image: {
          src: block.image?.[0]?.src || '',
          alt: block.image?.[0]?.alt || '',
          title: block.image?.[0]?.title || '',
        },
        link: {
          title: block.link?.[0]?.title || '',
          href: block.link?.[0]?.href || '',
          target: block.link?.[0]?.newWindow === '_blank' ? '_blank' : '_self',
          isExternalLink: block.link?.[0]?.type === 'external',
        },
      })),
    };
  };
}
